import React from "react";
import PropTypes from "prop-types";
import SurvivabilityChart from "../SurvivabilityChart";
import PFS_LOW_RISK_DATA from "./pfsLowRiskData";
import PFS_HIGH_RISK_DATA from "./pfsHighRiskData";

function PSAProgressionFreeChart({ predictions, onChartChange }) {
  return (
    <SurvivabilityChart
      id="psaProgressionFreeChart"
      highRiskData={PFS_HIGH_RISK_DATA}
      lowRiskData={PFS_LOW_RISK_DATA}
      predictionsData={[
        { time: 3, survivability: predictions.psaProgressionFreeSurvival3Months },
        { time: 6, survivability: predictions.psaProgressionFreeSurvival6Months },
      ]}
      onChartChange={onChartChange}
    />
  );
}

PSAProgressionFreeChart.propTypes = {
  predictions: PropTypes.shape({
    psaProgressionFreeSurvival3Months: PropTypes.number.isRequired,
    psaProgressionFreeSurvival6Months: PropTypes.number.isRequired,
  }),
  onChartChange: PropTypes.func.isRequired,
};

export default PSAProgressionFreeChart;
